import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import loginReducer from 'reducers/loginReducer';
import passwordRecoveryReducer from 'reducers/passwordRecoveryReducer';
import registrationReducer from 'reducers/registrationReducer';
import createNewPasswordReducer from 'reducers/createNewPasswordReducer';
import supportInfoReducer from 'reducers/supportInfoReducer';
import redirectionReducer from 'reducers/redirectionReducer';
import verificationReducer from 'reducers/verificationReducer';
import userReducer from 'reducers/userReducer';

const rootReducer = combineReducers({
  createNewPassword: createNewPasswordReducer,
  user: userReducer,
  login: loginReducer,
  redirection: redirectionReducer,
  verification: verificationReducer,
  passwordRecovery: passwordRecoveryReducer,
  registration: registrationReducer,
  routing: routerReducer,
  supportInfo: supportInfoReducer
});

export default rootReducer;
